// Site configuration stored in localStorage
// Used by Admin Panel to persist settings

export interface SocialLinks {
  instagram: string
  whatsapp: string
  telegram: string
  facebook: string
  youtube: string
}
export interface ContactInfo {
  phone: string
  email: string
  address: string
  instagram: string
  workdaysHours: string
  weekendHours: string
}
export interface CatalogSettings {
  showPrices: boolean
}
export interface SiteConfig {
  contacts: ContactInfo
  social: SocialLinks
  catalog: CatalogSettings
}
const DEFAULT_CONFIG: SiteConfig = {
  contacts: {
    phone: '+996 502 100 636',
    email: 'info@yavuzburak.kg',
    address: 'г. Бишкек, ул. Ю. Фучика 9а',
    instagram: '@yavuzburak.kg',
    workdaysHours: 'Пн-Пт: 9:00 - 18:00',
    weekendHours: 'Сб-Вс: Выходной',
  },
  social: {
    instagram: 'https://instagram.com/yavuzburak.kg',
    whatsapp: 'https://wa.me/996502100636',
    telegram: 'https://t.me/yavuzburak',
    facebook: 'https://facebook.com/yavuzburak',
    youtube: '',
  },
  catalog: {
    showPrices: true,
  },
}
export function getSiteConfig(): SiteConfig {
  try {
    const stored = localStorage.getItem('yb_site_config')
    if (stored) {
      const parsed = JSON.parse(stored)
      return {
        contacts: {
          ...DEFAULT_CONFIG.contacts,
          ...parsed.contacts,
        },
        social: {
          ...DEFAULT_CONFIG.social,
          ...parsed.social,
        },
        catalog: {
          ...DEFAULT_CONFIG.catalog,
          ...parsed.catalog,
        },
      }
    }
  } catch {}
  return DEFAULT_CONFIG
}
export function saveSiteConfig(config: SiteConfig): void {
  localStorage.setItem('yb_site_config', JSON.stringify(config))
}
export function getAdminPassword(): string {
  return localStorage.getItem('yb_admin_password') || 'yavuz2024'
}
export function setAdminPassword(password: string): void {
  localStorage.setItem('yb_admin_password', password)
}
